import React, { useState, useEffect } from 'react';
import { Button, Container, Form, Col, Row } from 'react-bootstrap';
import { useAuth } from '../Context/AuthContext';
import { db } from '../firebase-config';
import { collection, getDocs, doc, updateDoc } from "firebase/firestore";
import StatusSpinner from '../Components/StatusSpinner';

import { toast } from 'react-toastify';

export default function EmployeeDefaultRateSettings() {
    const { showSpinner, setShowSpinner } = useAuth();
    const [truckCharge, setTruckCharge] = useState("0");
    const [dailyRates, setDailyRates] = useState({Monday: "0", Tuesday: "0", Wednesday:"0", Thursday:"0", Friday:"0", Saturday:"0", Sunday:"0"});

    useEffect(()=>{
        setShowSpinner(true);
        getDocs(collection(db, "rates")).then((snapShot)=>{
            let tempTruckCharge = "0";
            let tempDailyRates = {Monday: "0", Tuesday: "0", Wednesday:"0", Thursday:"0", Friday:"0", Saturday:"0", Sunday:"0"};
            snapShot.forEach((doc)=>{
                if(doc.id === 'truck'){
                    tempTruckCharge = doc.data().rate;
                }
                if(doc.id === 'daily_tech_rates'){
                    tempDailyRates = doc.data();
                }
            });
            return {truckCharge: tempTruckCharge, dailyRates: tempDailyRates};
        }).then((info)=>{
            setShowSpinner(false);
            setTruckCharge(info.truckCharge);
            setDailyRates(info.dailyRates);
        }).catch((error)=>{
            setShowSpinner(false);
            toast.error(`Error getting rates list: ${error.message}`);
        });
    },[setShowSpinner]);

    const updateDailyRates = (day, value) =>{
        let tempDailyRates = {...dailyRates,
            [day]: value,
        };
        setDailyRates(tempDailyRates);
    };

    const saveTruckCharge = () =>{
        const truckChargeRef = doc(db, "rates", "truck");
        setShowSpinner(true);
        updateDoc(truckChargeRef, {rate: truckCharge}).then(()=>{
            setShowSpinner(false);
            toast.success('Truck Charge has been updated');
        }).catch((error)=>{
            setShowSpinner(false);
            toast.error(`Error saving truck charges: ${error.message}`);
        });
    };
    const saveDailyRates = () =>{
        const dailyRatesRef = doc(db, "rates", "daily_tech_rates");
        setShowSpinner(true);
        updateDoc(dailyRatesRef, dailyRates).then(()=>{
            setShowSpinner(false);
            toast.success('Daily Rates have been updated');
        }).catch((error)=>{
            setShowSpinner(false);
            toast.error(`Error saving daily rates: ${error.message}`);
        });
    };
    return(
        <>
            <Container fluid style={{width:"100%",paddingLeft:"65px", marginRight:"65px"}}>
                <Container fluid className="mt-5" style={{fontSize:"1.5em", letterSpacing:"0.2em"}}>
                    <Row className="justify-content-center">
                        DEFAULT RATE SETTINGS
                    </Row>
                </Container>
            </Container>
            <Container fluid className="d-flex align-items-center justify-content-center" style={{width:"100%", paddingLeft:"70px", marginRight:"70px"}}>
                <div className="w-100" style={{maxWidth: "700px"}}>
                    <div className="mt-5">
                        <Form.Group  style={{textAlign:"left"}} id="admin-set-email">
                            <Row>
                                <Col style={{textAlign:"right"}}>
                                    <Form.Label>Truck Charge:</Form.Label>
                                </Col>
                                <Col>
                                    <Form.Control style={{width:100}} min="0" type="number" value={truckCharge} onChange={(event)=>{
                                        setTruckCharge(event.target.value)
                                    }} />
                                </Col>
                                <Col>
                                    <Button
                                        className="btn-dark"
                                        style={{backgroundColor:"#2596be"}}
                                        onClick={()=>{
                                            saveTruckCharge();
                                        }}
                                        >
                                        SAVE TRUCK CHARGE
                                    </Button>
                                </Col>
                            </Row>
                        </Form.Group>
                    </div>
                </div>
            </Container>
            <Container fluid className="d-flex align-items-center justify-content-center" style={{width:"100%", paddingLeft:"70px", marginRight:"70px"}}>
                <div className="w-100" style={{maxWidth: "700px"}}>
                    <div className="mt-5">
                        <Form.Group  style={{textAlign:"left"}} id="admin-set-email">
                            <Row>
                                <Col style={{textAlign:"right"}}>
                                    <Form.Label>Monday Rate:</Form.Label>
                                </Col>
                                <Col>
                                    <Form.Control style={{width:100}} min="0" type="number" value={dailyRates?.Monday} onChange={(event)=>{
                                        updateDailyRates('Monday', event.target.value)
                                    }} />
                                </Col>
                                <Col></Col>
                            </Row>
                            <Row>
                                <Col style={{textAlign:"right"}}>
                                    <Form.Label style={{marginTop:10}}>Tuesday Rate:</Form.Label>
                                </Col>
                                <Col>
                                    <Form.Control style={{marginTop:10,width:100}} min="0" type="number" value={dailyRates?.Tuesday} onChange={(event)=>{
                                        updateDailyRates('Tuesday', event.target.value)
                                    }} />
                                </Col>
                                <Col></Col>
                            </Row>
                            <Row>
                                <Col style={{textAlign:"right"}}>
                                    <Form.Label style={{marginTop:10}}>Wednesday Rate:</Form.Label>
                                </Col>
                                <Col>
                                    <Form.Control style={{marginTop:10,width:100}} min="0" type="number" value={dailyRates?.Wednesday} onChange={(event)=>{
                                        updateDailyRates('Wednesday', event.target.value)
                                    }} />
                                </Col>
                                <Col></Col>
                            </Row>
                            <Row>
                                <Col style={{textAlign:"right"}}>
                                    <Form.Label style={{marginTop:10}}>Thursday Rate:</Form.Label>
                                </Col>
                                <Col>
                                    <Form.Control style={{marginTop:10,width:100}} min="0" type="number" value={dailyRates?.Thursday} onChange={(event)=>{
                                        updateDailyRates('Thursday', event.target.value)
                                    }} />
                                </Col>
                                <Col></Col>
                            </Row>
                            <Row>
                                <Col style={{textAlign:"right"}}>
                                    <Form.Label style={{marginTop:10}}>Friday Rate:</Form.Label>
                                </Col>
                                <Col>
                                    <Form.Control style={{marginTop:10,width:100}} min="0" type="number" value={dailyRates?.Friday} onChange={(event)=>{
                                        updateDailyRates('Friday', event.target.value)
                                    }} />
                                </Col>
                                <Col></Col>
                            </Row>
                            <Row>
                                <Col style={{textAlign:"right"}}>
                                    <Form.Label style={{marginTop:10}}>Saturday Rate:</Form.Label>
                                </Col>
                                <Col>
                                    <Form.Control style={{marginTop:10,width:100}} min="0" type="number" value={dailyRates?.Saturday} onChange={(event)=>{
                                        updateDailyRates('Saturday', event.target.value)
                                    }} />
                                </Col>
                                <Col></Col>
                            </Row>
                            <Row>
                                <Col style={{textAlign:"right"}}>
                                    <Form.Label style={{marginTop:10}}>Sunday Rate:</Form.Label>
                                </Col>
                                <Col>
                                    <Form.Control style={{marginTop:10,width:100}} min="0" type="number" value={dailyRates?.Sunday} onChange={(event)=>{
                                        updateDailyRates('Sunday', event.target.value)
                                    }} />
                                </Col>
                                <Col>
                                    <Button
                                        className="btn-dark"
                                        style={{marginTop:10,backgroundColor:"#2596be"}}
                                        onClick={()=>{
                                            saveDailyRates();
                                        }}
                                        >
                                        SAVE DAILY RATES
                                    </Button>
                                </Col>
                            </Row>
                        </Form.Group>
                    </div>
                </div>
            </Container>
            {
                showSpinner &&
                <StatusSpinner />
            }
        </>
    )
};